<template>
  <v-card>
    <v-card-title class="d-flex">
      <h2 class="dialog-title">What's included in this?</h2>
      <v-btn icon class="btn-close" aria-label="Close" @click="hideModal">
        <img src="@/assets/icons/ic_close.svg" />
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <DialogContentWhatsIncludedRentProtection
        @click:hideDialog="hideModal"
        noPadding
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { DIALOG_MODULE } from "@/store/types/module-types";
import { mapMutations } from "vuex";
import DialogContentWhatsIncludedRentProtection from "@/components/QuoteResult/landlords/DialogContentWhatsIncludedRentProtection.vue";
export default {
  name: `DialogLandLordsRentProtection`,
  components: {
    DialogContentWhatsIncludedRentProtection,
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, [`hideModal`]),
  },
};
</script>

<style lang="scss"></style>
